import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['stepContent', 'next', 'prev', 'complete']
  static values = { currentStep: Number }

  declare readonly stepContentTargets: HTMLElement[]
  declare readonly completeTarget: HTMLElement
  declare readonly nextTarget: HTMLElement
  declare readonly prevTarget: HTMLElement
  declare currentStepValue: number

  initialize (): void {
    if (this.currentStepValue === undefined) {
      this.currentStepValue = 0
    }
    this.showCurrentStep()
  }

  currentStepValueChanged (): void {
    this.showCurrentStep()
  }

  next (): void {
    if (this.currentStepValue < this.stepContentTargets.length - 1) {
      this.currentStepValue++
    }
  }

  prev (): void {
    if (this.currentStepValue > 0) {
      this.currentStepValue--
    }
  }

  private showCurrentStep (): void {
    this.stepContentTargets.forEach((step, index) => {
      step.classList.toggle('hidden', index !== this.currentStepValue)
    })

    const isLastStep = this.currentStepValue === this.stepContentTargets.length - 1
    const isFirstStep = this.currentStepValue === 0

    this.nextTarget?.classList.toggle('hidden', isLastStep)
    this.prevTarget?.classList.toggle('hidden', isFirstStep)
    this.completeTarget?.classList.toggle('hidden', !isLastStep)
  }
}
